/* eslint-disable @next/next/no-img-element */
import PropTypes from "prop-types";
import { Link as AnchorLink } from "../../../utils/Link";
import { social } from "./footerData";

export default function Footer({ Link, ExternalLink }) {
  // remove when oneTrust is implmented at the blog app
  const isRenderedAtBlogApp =
    typeof window !== "undefined" &&
    window.location.href.indexOf("company") > -1;

  return (
    <footer aria-labelledby="footerHeading" className="gn-footer">
      <h2 id="footerHeading" className="sr-only">
        Footer
      </h2>
      <div className="bg-gray-900 pt-lg">
        <div className="container mx-auto md:grid md:grid-cols-5 gap-sm md:gap-lg pt-lg pb-xl">
          <div className="space-y-sm pb-md md:pb-0">
            <Link
              href="/"
              className="mb-sm"
              events={[
                {
                  event: "Link Clicked",
                  properties: {
                    title: "GoNoodle Logo",
                    sourceElement: "footer",
                    sourceName: "footer",
                  },
                },
              ]}
            >
              <span className="sr-only">GoNoodle</span>
              <img
                className="w-36 -inset-x-sm mb-sm relative transform transition hover:scale-110 hover:-translate-y-xs"
                src="https://cdn.gonoodle.com/Universe-Component-Library/general/GoNoodleLogo_Registered_Reverse.svg"
                alt="GoNoodle logo"
              />
            </Link>
            <Link
              href="/company/p/who-we-are"
              className="block gn-text-sm text-gray-300 hover:text-mint"
              events={[
                {
                  event: "Link Clicked",
                  properties: {
                    title: "Who We Are",
                    sourceElement: "footer",
                    sourceName: "footer",
                  },
                },
              ]}
            >
              Who We Are
            </Link>
            <ExternalLink
              href="https://www.amazon.com/stores/page/BBE94FF8-64FA-40E2-87C7-BFAFD07D26D3"
              className="block gn-text-sm text-gray-300 hover:text-mint"
              events={[
                {
                  event: "Link Clicked",
                  properties: {
                    title: "GoNoodle Store",
                    sourceElement: "footer",
                    sourceName: "footer",
                  },
                },
              ]}
              linkParams={{
                title: "GoNoodle Store",
                sourceElement: "footer",
                sourceName: "footer",
              }}
            >
              GoNoodle Store
            </ExternalLink>
            <Link
              href="/company"
              className="block gn-text-sm text-gray-300 hover:text-mint"
              events={[
                {
                  event: "Link Clicked",
                  properties: {
                    title: "GoNoodle Blog",
                    sourceElement: "footer",
                    sourceName: "footer",
                  },
                },
              ]}
            >
              GoNoodle Blog
            </Link>
            <Link
              href="/company/press"
              className="block gn-text-sm text-gray-300 hover:text-mint"
              events={[
                {
                  event: "Link Clicked",
                  properties: {
                    title: "Press & Media",
                    sourceElement: "footer",
                    sourceName: "footer",
                  },
                },
              ]}
            >
              Press &amp; Media
            </Link>
            <Link
              href="https://support.gonoodle.com/"
              className="block gn-text-sm text-gray-300 hover:text-mint"
              events={[
                {
                  event: "Link Clicked",
                  properties: {
                    title: "Support",
                    sourceElement: "footer",
                    sourceName: "footer",
                  },
                },
              ]}
            >
              Support
            </Link>
          </div>

          <div className="space-y-sm">
            <p className="gn-text text-white uppercase font-bold mb-sm">
              Join the Movement!
            </p>
            <ExternalLink
              href="https://recruiting.paylocity.com/Recruiting/Jobs/All/709975d2-aa47-4b1f-adc7-e8605f11f7f3/GoNoodle-Inc"
              className="block gn-text-sm text-gray-300 hover:text-mint"
              events={[
                {
                  event: "Link Clicked",
                  properties: {
                    title: "Careers at GoNoodle",
                    sourceElement: "footer",
                    sourceName: "footer",
                  },
                },
              ]}
              linkParams={{
                title: "Careers at GoNoodle",
                sourceElement: "footer",
                sourceName: "footer",
              }}
            >
              Careers at GoNoodle
            </ExternalLink>
            <Link
              href="/company/p/contact-us"
              className="block gn-text-sm text-gray-300 hover:text-mint"
              events={[
                {
                  event: "Link Clicked",
                  properties: {
                    title: "Contact Us",
                    sourceElement: "footer",
                    sourceName: "footer",
                  },
                },
              ]}
            >
              Contact Us
            </Link>
            <Link
              href="/company/p/partner-with-us"
              className="block gn-text-sm text-gray-300 hover:text-mint"
              events={[
                {
                  event: "Link Clicked",
                  properties: {
                    title: "Partner With Us",
                    sourceElement: "footer",
                    sourceName: "footer",
                  },
                },
              ]}
            >
              Partner With Us
            </Link>
          </div>
          <div className="hidden lg:block">&nbsp;</div>
          <div className="col-span-3 lg:col-span-2 flex flex-col space-y-md mt-lg md:mt-0">
            <div>
              <p className="gn-text-sm text-white mb-sm">
                GoNoodle Video Apps are available for FREE!
              </p>
              <div className="flex flex-wrap">
                <ExternalLink
                  href="https://apps.apple.com/app/gonoodle-kids-videos/id1050712293"
                  className="block mr-sm mb-sm"
                  events={[
                    {
                      event: "Link Clicked",
                      properties: {
                        title:
                          "Download GoNoodle Video App on the Apple App Store",
                        sourceElement: "footer",
                        sourceName: "footer",
                      },
                    },
                  ]}
                  linkParams={{
                    title: "Download GoNoodle Video App on the Apple App Store",
                    sourceElement: "footer",
                    sourceName: "footer",
                  }}
                >
                  <span className="sr-only">
                    Download GoNoodle Video App on the Apple App Store
                  </span>
                  <img
                    src="https://cdn.gonoodle.com/Universe-Component-Library/general/badge-apple-appStore.svg"
                    alt="Apple App Store Badge"
                  />
                </ExternalLink>
                <ExternalLink
                  href="https://itunes.apple.com/us/app/gonoodle/id1050712293?mt=8&utm_campaign=Homepage&utm_medium=website&utm_source=gonoodle"
                  className="block mr-sm mb-sm"
                  events={[
                    {
                      event: "Link Clicked",
                      properties: {
                        title: "Download on Apple TV",
                        sourceElement: "footer",
                        sourceName: "footer",
                      },
                    },
                  ]}
                  linkParams={{
                    title: "Download on Apple TV",
                    sourceElement: "footer",
                    sourceName: "footer",
                  }}
                >
                  <span className="sr-only">Download on Apple TV</span>
                  <img
                    src="https://cdn.gonoodle.com/Universe-Component-Library/general/badge-appleTv.svg"
                    alt="Apple TV Badge"
                  />
                </ExternalLink>
                <ExternalLink
                  href="https://play.google.com/store/apps/details?id=com.gonoodle.gonoodle"
                  className="block mr-sm mb-sm"
                  events={[
                    {
                      event: "Link Clicked",
                      properties: {
                        title: "Download Video App on Google Play",
                        sourceElement: "footer",
                        sourceName: "footer",
                      },
                    },
                  ]}
                  linkParams={{
                    title: "Download Video App on Google Play",
                    sourceElement: "footer",
                    sourceName: "footer",
                  }}
                >
                  <span className="sr-only">Download on Google Play</span>
                  <img
                    src="https://cdn.gonoodle.com/Universe-Component-Library/general/badge-playStore.svg"
                    alt="Google Play Badge"
                  />
                </ExternalLink>
                <ExternalLink
                  href="https://channelstore.roku.com/details/09361a3e2de66cc65c3cb1fdf4d7127a/gonoodle"
                  className="block mr-sm mb-sm"
                  events={[
                    {
                      event: "Link Clicked",
                      properties: {
                        title: "Roku Players and TV",
                        sourceElement: "footer",
                        sourceName: "footer",
                      },
                    },
                  ]}
                  linkParams={{
                    title: "Roku Players and TV",
                    sourceElement: "footer",
                    sourceName: "footer",
                  }}
                >
                  <span className="sr-only">
                    Available on Roku Players and TV
                  </span>
                  <img
                    src="https://cdn.gonoodle.com/Universe-Component-Library/general/badge-roku.svg"
                    alt="Roku Badge"
                  />
                </ExternalLink>
                <ExternalLink
                  href="https://www.amazon.com/GoNoodle-Kids-Videos/dp/B07Y2J5V13"
                  className="block mr-sm mb-sm"
                  events={[
                    {
                      event: "Link Clicked",
                      properties: {
                        title: "Amazon App Store",
                        sourceElement: "footer",
                        sourceName: "footer",
                      },
                    },
                  ]}
                  linkParams={{
                    title: "Amazon App Store",
                    sourceElement: "footer",
                    sourceName: "footer",
                  }}
                >
                  <span className="sr-only">Available on Amazon App Store</span>
                  <img
                    src="https://cdn.gonoodle.com/Universe-Component-Library/general/badge-amazon.svg"
                    alt="Amazon App Store"
                  />
                </ExternalLink>
              </div>
            </div>
            <div>
              <p className="gn-text-sm text-white mb-sm">
                <Link
                  href="/company/games"
                  className="hover:scale-150"
                  events={[
                    {
                      event: "Link Clicked",
                      properties: {
                        title: "GoNoodle Games",
                        sourceElement: "footer",
                        sourceName: "footer",
                      },
                    },
                  ]}
                >
                  <span className="sr-only">GoNoodle Games!</span>
                  <img
                    className="inline-block mr-xs transform transition hover:scale-110 hover:-translate-y-xs"
                    src="https://cdn.gonoodle.com/Universe-Component-Library/general/logo-gn-games.svg"
                    alt="GoNoodle Games Logo"
                  />{" "}
                </Link>
                available for FREE!
              </p>
              <div className="flex flex-wrap">
                <ExternalLink
                  href="https://apps.apple.com/app/gonoodle-games/id1497169748"
                  className="block mr-sm mb-sm"
                  events={[
                    {
                      event: "Link Clicked",
                      properties: {
                        title: "Download GoNoodle Games on the Apple App Store",
                        sourceElement: "footer",
                        sourceName: "footer",
                      },
                    },
                  ]}
                  linkParams={{
                    title: "Download GoNoodle Games on the Apple App Store",
                    sourceElement: "footer",
                    sourceName: "footer",
                  }}
                >
                  <span className="sr-only">
                    Download GoNoodle Games on the Apple App Store
                  </span>
                  <img
                    src="https://cdn.gonoodle.com/Universe-Component-Library/general/badge-apple-appStore.svg"
                    alt="Apple App Store Badge"
                  />
                </ExternalLink>
                <ExternalLink
                  href="https://play.google.com/store/apps/details?id=com.gonoodle.gonoodlegames"
                  className="block mr-sm mb-sm"
                  events={[
                    {
                      event: "Link Clicked",
                      properties: {
                        title: "Download GoNoodle Games on Google Play",
                        sourceElement: "footer",
                        sourceName: "footer",
                      },
                    },
                  ]}
                  linkParams={{
                    title: "Download GoNoodle Games on Google Play",
                    sourceElement: "footer",
                    sourceName: "footer",
                  }}
                >
                  <span className="sr-only">Get it on Google Play</span>
                  <img
                    src="https://cdn.gonoodle.com/Universe-Component-Library/general/badge-playStore.svg"
                    alt="Google Play Badge"
                  />
                </ExternalLink>
                <ExternalLink
                  href="https://web.roblox.com/games/6772069048/GoNoodle-Hide-And-Seek-ALPHA"
                  className="block mr-sm mb-sm"
                  events={[
                    {
                      event: "Link Clicked",
                      properties: {
                        title: "Available on Roblox",
                        sourceElement: "footer",
                        sourceName: "footer",
                      },
                    },
                  ]}
                  linkParams={{
                    title: "Available on Roblox",
                    sourceElement: "footer",
                    sourceName: "footer",
                  }}
                >
                  <span className="sr-only">Available on Roblox</span>
                  <img
                    src="https://cdn.gonoodle.com/Universe-Component-Library/general/badge-roblox.svg"
                    alt="Roblox Badge"
                  />
                </ExternalLink>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-gray-800">
        <div className="container mx-auto flex flex-col md:flex-row space-y-sm md:space-y-0 justify-between items-center py-md">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <ExternalLink
              href="https://www.kidsafeseal.com/certifiedproducts/gonoodle_web_families.html"
              className="block w-2xl justify-center pb-md md:pb-0 md:w-28 md:mr-md md:align-center"
              events={[
                {
                  event: "Link Clicked",
                  properties: {
                    title: "kidSAFE Seal",
                    sourceElement: "footer",
                    sourceName: "footer",
                  },
                },
              ]}
              linkParams={{
                title: "kidSAFE Seal",
                sourceElement: "footer",
                sourceName: "footer",
              }}
            >
              <span className="sr-only">
                GoNoodle website for families (home version) is certified by the
                kidSAFE Seal Program.
              </span>
              <img
                src="https://www.kidsafeseal.com/sealimage/877468999199877006/gonoodle_web_families_svg_whitetm.svg"
                alt="COPPA Certified - Kid Safe"
              />
            </ExternalLink>
            <p className="block gn-text-xs text-white text-center px-xl md:px-0 md:text-left pb-md md:pb-0">
              Made with <span className="text-yellow">joy</span> for kids and
              the grownups who love them ❤️
            </p>
          </div>
          <div className="space-x-sm justify-end flex">
            {social.map((item) => (
              <ExternalLink
                key={item.name}
                href={item.href}
                className="text-white transition opacity-75 hover:opacity-100"
                events={[
                  {
                    event: "Link Clicked",
                    properties: {
                      title: item.name,
                      sourceElement: "footer",
                      sourceName: "footer",
                    },
                  },
                ]}
                linkParams={{
                  title: item.name,
                  sourceElement: "footer",
                  sourceName: "footer",
                }}
              >
                <span className="sr-only">{item.name}</span>
                <item.icon className="h-6 w-6" aria-hidden="true" />
              </ExternalLink>
            ))}
          </div>
        </div>
      </div>
      <div className="bg-gray-900">
        <div className="container mx-auto flex flex-col md:flex-row justify-between items-center py-sm">
          <div className="flex flex-row flex-wrap md:flex-nowrap justify-center">
            <Link
              href="/company/p/privacy-policy"
              className="block gn-text-xs text-white hover:text-yellow px-sm py-xs md:py-0"
              events={[
                {
                  event: "Link Clicked",
                  properties: {
                    title: "Privacy Policy",
                    sourceElement: "footer",
                    sourceName: "footer",
                  },
                },
              ]}
            >
              Privacy Policy
            </Link>
            <Link
              href="/company/p/tos"
              className="block gn-text-xs text-white hover:text-yellow px-sm py-xs md:py-0"
              events={[
                {
                  event: "Link Clicked",
                  properties: {
                    title: "Terms of Service",
                    sourceElement: "footer",
                    sourceName: "footer",
                  },
                },
              ]}
            >
              Terms of Service
            </Link>
            <Link
              href="/company/p/cookie-policy"
              className="block gn-text-xs text-white hover:text-yellow px-sm py-xs md:py-0"
              events={[
                {
                  event: "Link Clicked",
                  properties: {
                    title: "Cookie Policy",
                    sourceElement: "footer",
                    sourceName: "footer",
                  },
                },
              ]}
            >
              Cookie Policy
            </Link>
            {!isRenderedAtBlogApp ? (
              <button
                type="button"
                onClick={
                  typeof window !== "undefined" &&
                  window.OneTrust &&
                  window.OneTrust.ToggleInfoDisplay
                }
                className="block gn-text-xs text-white hover:text-yellow px-sm py-xs md:py-0"
              >
                Cookie Preferences
              </button>
            ) : null}

            <Link
              href="/company/p/accessibility-statement"
              className="block gn-text-xs text-white hover:text-yellow px-sm py-xs md:py-0"
              events={[
                {
                  event: "Link Clicked",
                  properties: {
                    title: "Accessibility Statement",
                    sourceElement: "footer",
                    sourceName: "footer",
                  },
                },
              ]}
            >
              Accessibility Statement
            </Link>
          </div>
          <p className="gn-text-xs text-white md:order-first my-sm md:my-0">
            &copy; {new Date().getFullYear()} GoNoodle, Inc.
          </p>
        </div>
      </div>
    </footer>
  );
}

Footer.propTypes = {
  Link: PropTypes.func,
  ExternalLink: PropTypes.func,
};

Footer.defaultProps = {
  Link: AnchorLink,
  ExternalLink: AnchorLink,
};
